// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles-module--wrap--1Z3QI","titleWrap":"styles-module--titleWrap--3Mprx","ctaWrap":"styles-module--ctaWrap--37v0p","link":"styles-module--link--1poDM"};